import { graphql } from "gatsby";
import React from "react";
import Card from "../components/Card";
import Layout from "../components/Layout";

const blogs = ({ data }) => {
  const post_data = data.allMarkdownRemark.nodes.map(
    ({ frontmatter: { title, slug, excerpt, thumbnail, tags, date } }) => ({
      title,
      slug,
      excerpt,
      thumbnail,
      tags,
      date,
    })
  );

  return (
    <Layout active="posts">
      <title>Blog posts | DoingCloudStuff</title>
      <h1 className="display-4 mt-5 mb-1 pt-5 pb-3">Posts</h1>

      <ul style={{ listStyle: "none", margin: "0", padding: "0" }}>
        {post_data.map(
          ({ title, slug, excerpt, thumbnail = "", tags, date }) => (
            <li
              key={slug}
              className="card my-3 p-3 row"
              style={{ border: "solid 1px #bbbbbb", borderRadius: "5px" }}
            >
              <Card
                title={title}
                slug={slug}
                excerpt={excerpt}
                thumbnail={thumbnail}
                tags={tags}
                date={date}
              />
            </li>
          )
        )}
      </ul>
    </Layout>
  );
};

export const query = graphql`
  {
    allMarkdownRemark(sort: { fields: frontmatter___date, order: DESC }) {
      nodes {
        frontmatter {
          author
          title
          slug
          excerpt
          date
          # thumbnail {
          #   childImageSharp {
          #     gatsbyImageData(width: 250)
          #   }
          # }
          tags
        }
      }
    }
  }
`;

export default blogs;
